import React from 'react';
import clone from 'clone';
import classNames from 'classnames';

class Tags extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
    };
  }
  componentWillMount() {
    this.setState({ options: this.props.options });
  }
  componentWillReceiveProps(nextprops) {
    // console.log(nextprops.options);
    this.setState({ options: nextprops.options });
  }
  render() {
    const options = clone(this.state.options);
    const childInputClass = classNames('input-container', this.props.isOpenElement);
    return (
      <div className={childInputClass}>
        <div className="taglists">
          <ul>
            { options.length ? options.map((tagItem, index) => {
              const CustomClassNameActive = classNames({
                'active-tag': tagItem.isActive === true,
              });
              return (
                <li key={'tag-' + index} className={CustomClassNameActive}>
                  <a className="tag-link" href="#" onClick={(e) => this.props.onSelectTags(e, tagItem)}>{tagItem.value}</a>
                </li>
              );
            }) : null }
          </ul>
        </div>
      </div>
    );
  }
}

Tags.propTypes = {
  'type': React.PropTypes.string,
  'value': React.PropTypes.array,
  'options': React.PropTypes.array,
  'onSelectTags': React.PropTypes.func,
  'isOpenElement': React.PropTypes.string,
};

export default Tags;



// WEBPACK FOOTER //
// ./assets/src/frontend/element/tag.js